import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useSidebarStore = create(
  persist(
    set => ({
      isOpen: false,
      setIsOpen: isOpen => set({ isOpen })
    }),
    { name: "sidebar" }
  )
);
